import $ from 'jquery';
import { selectBlockPageIsEditing } from '../../BlockPageUI/simpleSelectors';

// Always start in view mode
let wasEditing = false;

export const hideFooterOnBlockPageEdit = (state) => {
  const isEditing = selectBlockPageIsEditing(state);
  if (isEditing && !wasEditing) {
    $('.footer').hide();
  }
  if (!isEditing && wasEditing) {
    $('.footer').show();
  }
  wasEditing = isEditing;
  return Promise.resolve();
};
